import { Injectable } from '@angular/core';
import { AngularPlugin } from '@microsoft/applicationinsights-angularplugin-js';
import { ApplicationInsights, IExceptionTelemetry } from '@microsoft/applicationinsights-web';
import { environment } from 'src/environments/environment';
import { ICustomLogEvents } from '../interfaces/customLogEvents';

@Injectable({
  providedIn: 'root'
})
export class AppInsightService {
  private appInsights: ApplicationInsights;

  constructor() {
    const angularPlugin = new AngularPlugin();
    this.appInsights = new ApplicationInsights({
      config: {
        connectionString: environment.connectionString,
        enableAutoRouteTracking: false,
        disableExceptionTracking: true,
        enableDebug: false,
        extensions: [angularPlugin],
      }
    });
    this.appInsights.loadAppInsights();
  }

  logException(exception: Error, severityLevel?: number) {
    const emailId = localStorage.getItem("emailId")?.toLocaleLowerCase() || '';
    this.appInsights.trackException({
      exception: exception,
      //severityLevel: severityLevel,
      properties: { user: emailId }
  });
  }

  trackEvent(eventName: string, properties?: { [key: string]: string }) {
    if(properties?.['message'] && properties?.['message'].length > 50){
      eventName += ` (${properties?.['message'].substring(0,47)}...)`;
    } else {
      eventName += ' (' + properties?.['message'] + ')';
    }
    this.appInsights?.trackEvent({ name: eventName }, properties);
  }
  
  trackMetric(metricName: string, value: number, properties?: { [key: string]: string }) {
    this.appInsights?.trackMetric({ name: metricName, average: value }, properties);
  }
  
  trackTrace(message: string, properties?: { [key: string]: string }) {
    this.appInsights?.trackTrace({ message }, properties);
  }

    trackErrorEvent(eventName: string, param: any, statusCode: any, statusMessage: any, error: Error, properties?: { [key: string]: string }) {
    const emailId = localStorage.getItem("emailId")?.toLocaleLowerCase() || '';
      const errorProperties = {
      message: statusMessage,
      stack: error,
      statusCode: statusCode,
      param: param,
      properties,
      user: emailId
    };
    this.appInsights?.trackEvent({ name: eventName, properties: errorProperties });
  }

  trackPageView(name?: string, url?: string, properties?: { [key: string]: any }) {
    this.appInsights.trackPageView({ name, uri: url, properties });
  }

  trackPageEvent(name?: string, event?: string,log?: ICustomLogEvents ) {
    const emailId = localStorage.getItem("emailId")?.toLocaleLowerCase() || '';
    this.appInsights.trackEvent({
      name: log?.message ? `${name}-${event}-${log?.message}` : `${name}-${event}`,
      properties: { user: emailId, ...log, event: event },     
    });
  }
  
}